<ng-template #quantityLimitModal>
  <div class="modal-header border-bottom-0 px-4 pt-4">
    <h2 id="quantityLimitModalTitle" class="modal-title font-bold sanofi-orderCapping__modalTitle">{{ 'orderCapping.quantityLimit.modalTitle' | cxTranslate }}</h2>
  </div>
  <div class="modal-body px-4 pb-4">
    <p>
      {{ 'orderCapping.quantityLimit.description_other' | cxTranslate: { count: orderCappingDetails()?.allocatedQty } }}
      <a href='mailto:{{ emailAddress }}'>{{ emailAddress }}</a>
    </p>

    @if (baseProductName()) {
      <p class="font-bold"> {{ 'orderCapping.quantityLimit.palDisclaimer' | cxTranslate: { baseProductName: baseProductName() } }}</p>
    }

    <section>
      <div class="d-flex justify-content-between flex-fill mb-3">
        <span>{{ 'orderCapping.quantityLimit.totalAllocation' | cxTranslate }}</span>
        <span>{{ 'orderCapping.quantityLimit.unit' | cxTranslate: { count: orderCappingDetails()?.allocatedQty } }}</span>
      </div>
      <div class="d-flex justify-content-between flex-fill mb-3 border-bottom pb-2">
        <span>{{ 'orderCapping.quantityLimit.unitsOrdered' | cxTranslate }}</span>
        <span>{{ 'orderCapping.quantityLimit.unit' | cxTranslate: { count: orderCappingDetails()?.consumedQty } }}</span>
      </div>
      <div class="d-flex justify-content-between flex-fill sanofi-orderCapping__unitsRemaning font-bold">
        <span>{{ 'orderCapping.quantityLimit.unitsRemaining' | cxTranslate }}</span>
        <span>{{ 'orderCapping.quantityLimit.unit' | cxTranslate: { count: orderCappingDetails()?.availableQty } }}</span>
      </div>
    </section>
  </div>
</ng-template>

<ng-template #quantityLimitReachedWarningModal let-modal>
  <div class="modal-header border-bottom-0 px-4">
    <cx-icon class="mr-2 sanofi-orderCapping__warningIcon" [type]="ICON_TYPE.WARNING"/>
    <h2 class="modal-title">{{ 'orderCapping.quantityLimit.limitReached' | cxTranslate: { count: orderCappingDetails()?.allocatedQty } }}</h2>
    <button class="sanofi-orderCapping__modalCloseBtn close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      {{ 'orderCapping.goBack' | cxTranslate }}
    </button>
  </div>
</ng-template>

@if (!firstLoad()) {
  <sanofi-order-capping-toasts
    [allocatedQty]="orderCappingDetails()?.allocatedQty || '0'"
    [limitReached]="quantityLimitReached()"
    [productAnchorId]="productAnchorId()"
  />
}

<div class="sanofi-orderCapping my-2">
  <button class="sanofi-orderCapping__pill sanofi-orderCapping__pill--{{pillContext()}} py-2 px-3 text-white border-0"
          [placement]="popoverPlacement()"
          [ngbPopover]="quantityLimitModal" triggers="manual"
          [disablePopover]="isModalOpen()"
          closeDelay="0"
          openDelay="0"
          #limitPopover="ngbPopover"
          popoverClass="sanofi-orderCapping__popover"
          (mouseenter)="limitPopover.open()"
          (mouseleave)="limitPopover.close()"
          (click)="openModal()"
          [autoClose]="false"
  >
    <fa-icon [icon]="pillIcon()" class="sanofi-orderCapping__pillIcon mr-2" />
    <span>
      {{ ['orderCapping.type', 'orderCapping.typeUnknown'] | cxTranslate: { context: pillContext() } }}
    </span>
  </button>

  @if (cartMode() && orderCappingDetails()) {
    <div class="sanofi-orderCapping__allocationBox mt-2 px-3 py-2">
      <div class="sanofi-orderCapping__allocationStats">
        <span>{{ 'orderCapping.quantityLimit.unit' | cxTranslate: { count: orderCappingDetails()?.allocatedQty } }}</span>
        <span class="sanofi-orderCapping__allocationSeparator mx-2">|</span>
        <span>{{ remainingAfterCart() }} remaining</span>
      </div>
      <div class="sanofi-orderCapping__allocationLabel">{{ 'orderCapping.quantityLimit.allocatedUnits' | cxTranslate }}</div>
    </div>
  }
</div>
